import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink } from 'react-router-dom';
import cn from 'classnames';
import {
  Jumbotron,
  Nav,
  NavItem,
} from 'reactstrap';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';

import ResourceTab from './ResourceTab';
import styles from './styles.scss';

const IconEmails = () => (
  <svg fill="#FFF" height="25px" width="25px" viewBox="0 0 75.294 75.294">
    <g>
      <path d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
        c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
        H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
        c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
        c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
        c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
        c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"
      />
    </g>
  </svg>
);

const IconLandingPages = () => (
  <svg width="23px" height="20px" viewBox="0 0 23 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-516.000000, -260.000000)" fill="#FFFFFF" fillRule="nonzero">
        <g transform="translate(0.000000, 242.000000)">
          <path d="M529.214286,18 L537.785714,18 C538.377455,18 538.857143,18.4796875 538.857143,19.0714286 L538.857143,26.2142857 C538.857143,26.8060268 538.377455,27.2857143 537.785714,27.2857143 L529.214286,27.2857143 C528.622545,27.2857143 528.142857,26.8060268 528.142857,26.2142857 L528.142857,19.0714286 C528.142857,18.4796875 528.622545,18 529.214286,18 Z M525.642857,18 L517.071429,18 C516.479687,18 516,18.4796875 516,19.0714286 L516,26.2142857 C516,26.8060268 516.479687,27.2857143 517.071429,27.2857143 L525.642857,27.2857143 C526.234598,27.2857143 526.714286,26.8060268 526.714286,26.2142857 L526.714286,19.0714286 C526.714286,18.4796875 526.234598,18 525.642857,18 Z M516,29.7857143 L516,36.9285714 C516,37.5203125 516.479687,38 517.071429,38 L525.642857,38 C526.234598,38 526.714286,37.5203125 526.714286,36.9285714 L526.714286,29.7857143 C526.714286,29.1939732 526.234598,28.7142857 525.642857,28.7142857 L517.071429,28.7142857 C516.479687,28.7142857 516,29.1939732 516,29.7857143 Z M529.214286,38 L537.785714,38 C538.377455,38 538.857143,37.5203125 538.857143,36.9285714 L538.857143,29.7857143 C538.857143,29.1939732 538.377455,28.7142857 537.785714,28.7142857 L529.214286,28.7142857 C528.622545,28.7142857 528.142857,29.1939732 528.142857,29.7857143 L528.142857,36.9285714 C528.142857,37.5203125 528.622545,38 529.214286,38 Z" id="Shape" />
        </g>
      </g>
    </g>
  </svg>
);

const IconGuides = () => (
  <svg width="20px" height="24px" viewBox="0 0 20 24">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-674.000000, -258.000000)" fill="#FFFFFF" fillRule="nonzero">
        <g transform="translate(0.000000, 242.000000)">
          <path d="M694,32.5 L694,17.6428571 C694,16.9285714 693.571429,16.5 692.857143,16.5 L678.285714,16.5 C675.857143,16.5 674,18.3571429 674,20.7857143 L674,35.0714286 C674,37.5 675.857143,39.3571429 678.285714,39.3571429 L692.857143,39.3571429 C693.428571,39.3571429 694,38.9285714 694,38.2142857 L694,37.5 C694,37.2142857 693.857143,36.9285714 693.571429,36.6428571 C693.428571,35.9285714 693.428571,33.9285714 693.571429,33.3571429 C693.857143,33.2142857 694,32.9285714 694,32.5 Z M691,36.5 L678.285714,36.5 C677.428571,36.5 676.857143,35.9285714 676.857143,35.0714286 C676.857143,34.2142857 677.571429,33.6428571 678.285714,33.6428571 L691,33.6428571 L691,36.5 Z" id="Shape" />
        </g>
      </g>
    </g>
  </svg>
);

const MarketingResources = (props) => {
  const [activePath, setActivePath] = useState('');
  const { location: { pathname }, match: { path } } = props;

  useEffect(() => {
    const pathArray = pathname.split(path);
    setActivePath(pathArray[pathArray.length - 1]);
  }, [pathname]);

  return (
    <div className={styles['page-resource-center']}>
      <Header />
      <div>

        <Jumbotron className={cn('text-center px-0 pb-0 pt-4', styles.jumbo)}>
          <h1 className="pt-1 pb-1">Marketing Resources</h1>
          <p className="pb-3">Tools and resources to help your business grow</p>

          <Nav className={`justify-content-center mt-4 ${styles.nav}`}>
            <NavItem>
              <NavLink to={`${path}`} className={`${styles['nav-link']} ${activePath === '' ? styles.active : ''}`} exact>
                <IconEmails />
                Emails
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={`${path}/guides`} className={`${styles['nav-link']} ${activePath === '/guides' ? styles.active : ''}`}>
                <IconGuides />
                Guides
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to={`${path}/landing-pages`} className={`${styles['nav-link']} ${activePath === '/landing-pages' ? styles.active : ''}`}>
                <IconLandingPages />
                Landing Pages
              </NavLink>
            </NavItem>
          </Nav>
        </Jumbotron>
      </div>

      <section className="container section mb-1">
        <div className="grid-container fluid page-applications">
          <Grid>
            <Column className="small-12 card-grid-container pb-0">

              <Grid className={cn('grid-margin-x mt-1')}>
                <Switch>
                  <Route path={`${path}`} exact component={() => <ResourceTab type="email" />} />
                  <Route path={`${path}/landing-pages`} component={() => <ResourceTab type="landing_page" />} />
                  <Route path={`${path}/guides`} component={() => <ResourceTab type="guide" />} />
                </Switch>
              </Grid>
            </Column>
          </Grid>
        </div>
      </section>

    </div>
  );
};

MarketingResources.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default MarketingResources;



// WEBPACK FOOTER //
// ./src/containers/pages/MarketingResources/index.js